/* Pouches LP - build your own bundle.
   Tier = how many cans (3/6/9). Picking a tier fills it with that tier's preset mix (e.g. 1,1,1,0), so
   the button is ready to buy straight away. The mix must add up to exactly the tier: + locks when it
   is full; if a can is removed the button keeps its price but reads "ADD 1 MORE CAN" and can't be
   clicked until the tier is full again. The price shown is the live variant prices; the free cans are the
   cheapest chosen cans, which is exactly what the $8-per-free-can automatic discounts take off
   while every can costs the same. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.pbReady === '1') return;
    var cfgEl = root.parentNode && root.parentNode.querySelector('[data-pb-config]');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    root.dataset.pbReady = '1';

    var fmt;
    try {
      fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: cfg.currency || 'USD', currencyDisplay: 'narrowSymbol' });
    } catch (e) {
      fmt = { format: function (n) { return '$' + n.toFixed(2); } };
    }
    /* whole amounts print without .00, like the comp ("$48 $40") */
    function money(cents) {
      var s = fmt.format(cents / 100);
      return cents % 100 === 0 ? s.replace(/[.,]00(?=\D*$)/, '') : s;
    }

    var tiers = cfg.tiers || [];
    var state = { tier: Math.min(Math.max(cfg.defaultTier || 0, 0), tiers.length - 1), qty: {}, order: [] };

    var cards = [].slice.call(root.querySelectorAll('[data-pb-flavour]'));
    var tierBtns = [].slice.call(root.querySelectorAll('[data-pb-tier]'));
    var atc = root.querySelector('[data-pb-atc]');
    var atcText = root.querySelector('[data-pb-atc-text]');
    var errEl = root.querySelector('[data-pb-error]');

    function flav(id) {
      for (var i = 0; i < cfg.flavours.length; i++) if (String(cfg.flavours[i].variant) === String(id)) return cfg.flavours[i];
      return null;
    }
    function max() { return tiers[state.tier] ? tiers[state.tier].qty : 0; }
    function count() { var n = 0; for (var k in state.qty) n += state.qty[k]; return n; }

    function clamp() {
      /* drop the most recently added cans first */
      while (count() > max() && state.order.length) {
        var id = state.order.pop();
        if (state.qty[id]) { state.qty[id]--; if (!state.qty[id]) delete state.qty[id]; }
      }
    }

    /* preset "1,1,1,0" = cans per flavour card, in card order */
    function presetOf(i) {
      var t = tiers[i]; if (!t) return [];
      return String(t.preset || '').split(',').map(function (x) { return Math.max(0, parseInt(x, 10) || 0); });
    }
    function applyPreset(i) {
      var pre = presetOf(i), left = max();
      state.qty = {}; state.order = [];
      cards.forEach(function (c, k) {
        var id = c.getAttribute('data-pb-flavour'), f = flav(id), q = Math.min(pre[k] || 0, left);
        if (!f || !f.available) q = 0;
        for (var j = 0; j < q; j++) state.order.push(id);
        if (q) state.qty[id] = q;
        left -= q;
      });
    }
    /* price of a full tier, from its preset (falls back to the cheapest can x qty) */
    function tierPrices(i) {
      var t = tiers[i], pre = presetOf(i), unit = [];
      cards.forEach(function (c, k) {
        var f = flav(c.getAttribute('data-pb-flavour'));
        for (var j = 0; f && j < (pre[k] || 0); j++) unit.push(f.price);
      });
      if (unit.length !== t.qty) {
        var min = Math.min.apply(null, cfg.flavours.map(function (f) { return f.price; }));
        unit = []; for (var q = 0; q < t.qty; q++) unit.push(min);
      }
      unit.sort(function (a, b) { return a - b; });
      var full = unit.reduce(function (a, b) { return a + b; }, 0);
      var off = unit.slice(0, t.free || 0).reduce(function (a, b) { return a + b; }, 0);
      return { full: full, now: full - off };
    }
    function priceNodes(p) {
      var frag = document.createDocumentFragment();
      if (p.now < p.full) {
        var was = document.createElement('s'); was.className = 'pb__was'; was.textContent = money(p.full);
        frag.appendChild(was);
      }
      frag.appendChild(document.createTextNode(money(p.now)));
      return frag;
    }

    function prices() {
      var unit = [];
      for (var k in state.qty) {
        var f = flav(k);
        for (var i = 0; f && i < state.qty[k]; i++) unit.push(f.price);
      }
      unit.sort(function (a, b) { return a - b; });
      var full = unit.reduce(function (a, b) { return a + b; }, 0);
      var free = tiers[state.tier] ? tiers[state.tier].free || 0 : 0;
      var off = unit.slice(0, free).reduce(function (a, b) { return a + b; }, 0);
      return { full: full, now: full - off };
    }

    function render() {
      var n = count(), m = max();
      tierBtns.forEach(function (b, i) {
        b.classList.toggle('is-selected', i === state.tier);
        b.setAttribute('aria-pressed', i === state.tier ? 'true' : 'false');
      });
      cards.forEach(function (c) {
        var id = c.getAttribute('data-pb-flavour');
        var f = flav(id), q = state.qty[id] || 0;
        var out = !f || !f.available;
        c.classList.toggle('is-out', out);
        c.querySelector('[data-pb-qty]').textContent = q;
        c.querySelector('[data-pb-minus]').disabled = q === 0;
        c.querySelector('[data-pb-plus]').disabled = out || n >= m;
      });
      var complete = n === m && m > 0;
      atc.disabled = !complete;
      atcText.innerHTML = '';
      if (!complete) {
        /* stays blue and priced; only the label changes until the tier is full */
        var left = m - n;
        atcText.appendChild(document.createTextNode((cfg.text.more || 'Add [n] more can[s]').replace('[n]', left).replace('[s]', left === 1 ? '' : 's') + ' | '));
        atcText.appendChild(priceNodes(tierPrices(state.tier)));
        return;
      }
      atcText.appendChild(document.createTextNode(cfg.text.atc + ' | '));
      atcText.appendChild(priceNodes(prices()));
    }

    function showError(msg) { if (errEl) { errEl.textContent = msg; errEl.classList.add('is-visible'); } }
    function clearError() { if (errEl) errEl.classList.remove('is-visible'); }

    tierBtns.forEach(function (b, i) {
      b.addEventListener('click', function () { state.tier = i; applyPreset(i); clearError(); render(); });
    });
    cards.forEach(function (c) {
      var id = c.getAttribute('data-pb-flavour');
      c.querySelector('[data-pb-plus]').addEventListener('click', function () {
        var f = flav(id);
        if (!f || !f.available || count() >= max()) return;
        state.qty[id] = (state.qty[id] || 0) + 1;
        state.order.push(id);
        clearError(); render();
      });
      c.querySelector('[data-pb-minus]').addEventListener('click', function () {
        if (!state.qty[id]) return;
        state.qty[id]--;
        if (!state.qty[id]) delete state.qty[id];
        var at = state.order.lastIndexOf(id);
        if (at > -1) state.order.splice(at, 1);
        clearError(); render();
      });
    });

    /* Open the cart where the shopper already is: Rebuy drawer, then the theme's own trigger,
       and only navigate to /cart as a last resort. (Same order as the Switch Kit builder.) */
    function openCart() {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      try {
        if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
          window.Rebuy.SmartCart.show();
          return;
        }
      } catch (e) {}
      var trigger = document.querySelector('a.cart-link, [data-cart-toggle], .js-cart-trigger');
      if (trigger) { trigger.click(); return; }
      window.location.href = cfg.routes.cart;
    }

    atc.addEventListener('click', function () {
      if (atc.disabled) return;
      clearError();
      var items = [];
      cards.forEach(function (c) {
        var id = c.getAttribute('data-pb-flavour');
        if (state.qty[id]) items.push({ id: Number(id), quantity: state.qty[id] });
      });
      if (!items.length) return;
      atc.classList.add('is-loading');
      fetch(cfg.routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          atc.classList.remove('is-loading');
          if (!res.ok) throw new Error((res.body && (res.body.description || res.body.message)) || cfg.text.err);
          openCart();
        })
        .catch(function (err) {
          atc.classList.remove('is-loading');
          showError(err && err.message ? err.message : cfg.text.err);
        });
    });

    /* accordions */
    [].forEach.call(root.querySelectorAll('[data-pb-acc]'), function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.pb__acc');
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    /* gallery: the strip is moved with a transform (4px gutter between slides so a sub-pixel
       position can never show a sliver of the neighbour); arrows and thumbs wrap; swipe on touch */
    (function () {
      var track = root.querySelector('[data-pb-track]');
      var strip = root.querySelector('[data-pb-strip]');
      if (!track || !strip) return;
      var slides = [].slice.call(strip.querySelectorAll('[data-pb-slide]'));
      var thumbs = [].slice.call(root.querySelectorAll('[data-pb-thumb]'));
      var thumbBox = root.querySelector('[data-pb-thumbs]');
      if (!slides.length) return;
      var current = 0, n = slides.length;
      function attach(v) {
        if (v.getAttribute('data-pb-on')) return;
        var list;
        try { list = JSON.parse(v.getAttribute('data-pb-src') || '[]'); } catch (e) { list = []; }
        list.forEach(function (x) {
          var el = document.createElement('source');
          el.src = x.src; if (x.type) el.type = x.type;
          v.appendChild(el);
        });
        v.setAttribute('data-pb-on', '1');
        v.muted = true;
        try { v.load(); } catch (e) {}
      }
      /* video slides load the first time they are shown; only the visible one plays */
      function activate(i) {
        slides.forEach(function (sl, k) {
          var v = sl.querySelector('video[data-pb-src]');
          if (!v) return;
          if (k === i) { attach(v); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else { try { v.pause(); } catch (e) {} }
        });
      }
      function place(k, dx) {
        strip.style.transform = 'translateX(calc(' + (-k) + ' * (100% + 4px) + ' + (dx || 0) + 'px))';
      }
      function go(i) {
        current = ((i % n) + n) % n;
        strip.classList.remove('is-drag');
        place(current, 0);
        activate(current);
        thumbs.forEach(function (t, ti) { t.setAttribute('aria-current', ti === current ? 'true' : 'false'); });
        var t = thumbs[current];
        if (t && thumbBox) {
          var vertical = thumbBox.scrollHeight > thumbBox.clientHeight + 1;
          if (vertical) thumbBox.scrollTop = t.offsetTop - (thumbBox.clientHeight - t.offsetHeight) / 2;
          else thumbBox.scrollLeft = t.offsetLeft - (thumbBox.clientWidth - t.offsetWidth) / 2;
        }
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-pb-thumb'), 10) || 0); }); });
      var prev = root.querySelector('[data-pb-prev]'), next = root.querySelector('[data-pb-next]');
      if (prev) prev.addEventListener('click', function () { go(current - 1); });
      if (next) next.addEventListener('click', function () { go(current + 1); });
      var sx = null, sy = null, dx = 0, horiz = null;
      track.addEventListener('touchstart', function (e) { var p = e.touches[0]; sx = p.clientX; sy = p.clientY; dx = 0; horiz = null; }, { passive: true });
      track.addEventListener('touchmove', function (e) {
        if (sx === null) return;
        var p = e.touches[0]; dx = p.clientX - sx;
        if (horiz === null) horiz = Math.abs(dx) > Math.abs(p.clientY - sy);
        if (!horiz) return;
        strip.classList.add('is-drag');
        place(current, dx);
      }, { passive: true });
      track.addEventListener('touchend', function () {
        if (sx === null) return;
        sx = null;
        if (horiz && Math.abs(dx) > 50) go(current + (dx < 0 ? 1 : -1)); else go(current);
      }, { passive: true });
      go(0);
      root.__pbGo = go;
    })();

    root.__pb = { state: state, render: render, prices: prices };
    applyPreset(state.tier);
    render();
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-pb]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
